import { ADD_OWN_WORD, ADD_WORD_TO_LEARN, IS_FETCHING_USER, IS_WEB_TOKEN_VALID, FLAG_WORD_ASSET, RETURN_TEST_REPORTED_SUCCESSFULLY, SIGN_IN, SIGN_OUT, USER_FETCHED, REMOVE_FROM_CURRENT_3 } from "../actions/types";



const INITIAL_STATE = {
    user: {
        dateJoined: null,
        wordMoney: 0,
        wordsLearned: 0,
        lifeTimeProfit: 0,
        userName: null,
        firstName: null,
        lastName: null,
        email: null,
        current3: [],
        wordChallenges: [],
    },
    isSignedIn: false,
    isSigningIn: false
}

const authReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {


        case IS_WEB_TOKEN_VALID:
            if (!action.payload.isSignedIn) {
                return { ...state };
            }
            if (action.payload.isSignedIn) {
                return { user: action.payload.user, isSignedIn: action.payload.isSignedIn, isSigningIn: state.isSigningIn }
            }
            return state;

        case SIGN_IN:
            localStorage.setItem("auth-token", action.payload.token);
            return { user: action.payload.user, isSignedIn: action.payload.isSignedIn, isSigningIn: state.isSignedIn };


        case SIGN_OUT: {
            localStorage.setItem("auth-token", "");
            return INITIAL_STATE;
        }
        case ADD_WORD_TO_LEARN:
            return { ...state, user: { ...state.user, current3: action.payload.newCurrent3 } };

        case RETURN_TEST_REPORTED_SUCCESSFULLY:
            return { ...state, user: action.payload.user };
        case IS_FETCHING_USER:
            return { ...state, isSigningIn: true };
        case USER_FETCHED:
            return { ...state, isSigningIn: false };
        case ADD_OWN_WORD:
            return { ...state, user: { ...state.user, current3: action.payload.newCurrent3 } };
        case FLAG_WORD_ASSET:
            let newCurrent3 = [...state.user.current3];
            let valueOfFlag = newCurrent3.findIndex((item) => item.word.word === action.payload.word);
            if (valueOfFlag < 0) return state;
            newCurrent3[valueOfFlag].word.flagged = true;
            return { ...state, user: { ...state.user, current3: newCurrent3 } }
        case REMOVE_FROM_CURRENT_3: {
            return { ...state, user: { ...state.user, current3: action.payload.current3 } };
        }
        default:
            return state;
    }

}

export default authReducer;